import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Button,
  Color,
  Display,
  Display3,
  FontWeight,
  Heading4,
  Space,
  Visible,
} from '@gousto-internal/citrus-react'

import { HOW_OUR_RECIPE_BOXES_WORK } from '../../../config'
import { LandingPageContentSections, TrackingActions, trackCTAClick } from '../../../tracking'

type BenefitsProps = {
  signupCTA: string
  onCTAClick: () => void
}

const { header, benefits } = HOW_OUR_RECIPE_BOXES_WORK

export function Benefits({ signupCTA, onCTAClick }: BenefitsProps) {
  const clickCTA = () => {
    onCTAClick()
    trackCTAClick(
      TrackingActions.CLICK_GET_STARTED,
      LandingPageContentSections.EFFORTLESS_HOME_COOKING,
    )
  }

  const benefitList = benefits.map(({ title, description }, index) => (
    <Box key={`benefit-${index}`}>
      <Heading4
        size={[4, null, null, 6]}
        color={Color.ColdGrey_800}
        style={{ fontWeight: FontWeight.Bold }}
      >
        {index + 1}. {title}
      </Heading4>
      <Body2 size={[4, null, null, 6]} color={Color.ColdGrey_800}>
        {description}
      </Body2>
      <Space size={3} />
    </Box>
  ))

  return (
    <Box display={Display.Flex} alignItems={AlignItems.Center} width={[null, null, null, '100%']}>
      <Box>
        <Box paddingRight={0} width={[null, null, null, '350px']}>
          <Display3 color={Color.Primary_600}>{header}</Display3>
        </Box>
        <Space size={[4, null, null, 5]} />
        <Box maxWidth={[null, null, null, '380px']}>{benefitList}</Box>
        <Space size={3} />
        <Visible display={[Display.None, Display.Block, null, Display.Block]}>
          <Button width="320px" onClick={clickCTA} height="48px">
            {signupCTA}
          </Button>
          <Space size={[0, 3, 3, 0]} />
        </Visible>
      </Box>
    </Box>
  )
}
